export default __webpack_public_path__ + "static/biodiversity-807253e861b92148b1dab5ae103968bc.png";